import { defaultVisitors } from '@genericBookings/types/Visitors';
function visitorCountFromSchema(activitySchema) {
    return Array(9).fill(0).reduce((carry, _, idx) => {
        const key = `Visitors${idx}`;
        const currVisitor = activitySchema[key];
        if (currVisitor) {
            return currVisitor + carry;
        }
        return carry;
    }, 0);
}
export function visitorsFromSchema(activitySchema) {
    const visitors = {};
    Array(9).fill(0).forEach((_, idx) => {
        const key = `Visitors${idx}`;
        const currVisitor = activitySchema[key];
        visitors[`Visitors${idx}`] = currVisitor ?? 0;
    });
    return visitors;
}
export function visitorsFromVisitorsSchema(dayTicketSchema) {
    const visitors = {};
    Array(9).fill(0).forEach((_, idx) => {
        const key = `Visitors${idx}`;
        const currVisitor = (dayTicketSchema[key] ?? 0);
        visitors[`Visitors${idx}`] = currVisitor ?? 0;
    });
    return visitors;
}
export function visitorCount(visitors) {
    return Object.keys(visitors).reduce((carry, key, idx) => visitors[key] + carry, 0);
}
export function numberArrayToVisitors(visitorArray) {
    const visitors = { ...defaultVisitors };
    visitorArray.slice(0, 8).forEach((visitor, idx) => {
        visitors[`Visitors${idx}`] = visitor;
    });
    return visitors;
}
export function visitorSchemaFromVisitors(visitors, setValue) {
    Object.keys(visitors).forEach((visitor, idx) => {
        setValue(visitors[visitor], idx);
    });
}
export default visitorCountFromSchema;
